import styled from 'styled-components/macro'
import { motion } from 'framer-motion'
import { COLORS, FLEX_CONTAINER } from 'utils/styles'
import { DrawerContent } from '@chakra-ui/react'

const DrawerMotion = motion(DrawerContent)

export const StyledModalContainer = styled(DrawerMotion)`
  ${FLEX_CONTAINER.FlexColumn}
  gap: 7px;
  overflow: scroll;
  width: 365px;
  height: 85svh;
  margin-inline: auto;
  margin-block: 60px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  border: 1px solid #ccc;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar{
    display: none
  }
  
  @media (max-width: 480px) and (max-height: 800px) {
    width: 85svw;
  }

  @media (max-width: 450px) and (max-height: 800px) {
    width: 82svw;
  }

  @media (max-width: 390px) and  (max-height: 800px) {
    width: 330px;
  }
`
